(function () {
  // Skip on mobile (mimics isMobile behavior)
  if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return;
}

  // Create follower element
  const follower = document.createElement('div');
  follower.className = 'follower';
  document.body.appendChild(follower);

  // State
  let isMouseOver = false;
  let isMouseDragging = false;
  let isDisabled = false;
  let followerText = '';

  function updateClasses() {
    follower.classList.toggle('over', isMouseOver && !isDisabled);
    follower.classList.toggle('down', isMouseDragging);
    follower.classList.toggle('disabled', isDisabled);
    follower.textContent = followerText || '';
  }

  // Animate follower to mouse position
  function moveCircle(e) {
    const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (window.gsap) {
      gsap.to(follower, {
        duration: 0.3,
        left: e.pageX - scrollX,
        top: e.pageY - scrollY,
        ease: "power3.out"
      });
    } else {
      // Fallback without GSAP
      follower.style.left = (e.pageX - scrollX) + 'px';
      follower.style.top = (e.pageY - scrollY) + 'px';
    }
  }

  // Global interactions
  window.addEventListener('mousemove', moveCircle);
  window.addEventListener('mousedown', () => { isMouseDragging = true; updateClasses(); });
  window.addEventListener('mouseup', () => { isMouseDragging = false; updateClasses(); });

  // --- ACTIVATION LOGIC ---
  // 1) Any element with .work-listing__image-link (your Vue class)
  // 2) Any element with [data-follower] (generic opt-in)
  // Optional: set text with data-follower-text="View Project"

  const ACTIVATION_SELECTOR = '.shopify-follower';

  function handleEnter(el) {
    followerText = el.getAttribute('data-follower-text') || followerText || '';
    isMouseOver = true;
    updateClasses();
  }
  function handleLeave() {
    isMouseOver = false;
    // Don't clear text—keeps last message if you prefer; clear if you want:
    // followerText = '';
    updateClasses();
  }

  // Event delegation (so dynamically-added items work too)
  document.addEventListener('mouseover', (e) => {
    const target = e.target.closest(ACTIVATION_SELECTOR);
    if (!target) return;
    // Read text lazily (if text not set elsewhere)
    if (!target.hasAttribute('data-follower-text') && target.dataset.followerText == null) {
      // do nothing; use prior text or empty
    }
    handleEnter(target);
  });

  document.addEventListener('mouseout', (e) => {
    // Only react when leaving the activation element entirely
    const from = e.target.closest(ACTIVATION_SELECTOR);
    const to = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest(ACTIVATION_SELECTOR) : null;
    if (from && from !== to) handleLeave();
  });

  // Public API
  window.ShopifyFollower = {
    setText: (text) => { followerText = text; updateClasses(); },
    setOver: (val = true) => { isMouseOver = val; updateClasses(); },
    setDisabled: (val = true) => { isDisabled = val; updateClasses(); },
    destroy: () => {
      window.removeEventListener('mousemove', moveCircle);
      document.removeEventListener('mouseover', handleEnter);
      document.removeEventListener('mouseout', handleLeave);
      follower.remove();
    }
  };
})();
